import { QFilter } from '@/types';
import { SearchTreeNode } from '@/types/searchTreeTypes';
import { DomainCode } from '@australiangreens/ag-internal-components';
import { logger } from '@/util';
import callBackendApi from './call';

export const setSupporterStatus = async (
  token: string,
  values: { qFilter: QFilter; status: string; domainCode: DomainCode }
) => {
  logger.debug('setSupporterStatus() called', {});

  const data = await callBackendApi({
    token,
    method: 'put',
    endpoint: '/supporterstatuses',
    data: values,
  });

  return data;
};

export type SetSupporterStatusAdvData = {
  tree: SearchTreeNode;
  supporterStatus: 'P' | 'C' | 'X';
  domainCode: DomainCode;
};

// [LIST-680]
export const setSupporterStatusAdv = async (token: string, data: SetSupporterStatusAdvData) =>
  callBackendApi({
    token,
    method: 'put',
    endpoint: '/supporterstatuses/adv',
    data,
  });
